<template>
  <div>
    <Header />
    <Project2Details />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer";
import Header from "../components/Header"
import Project2Details from "../components/Project2Details";
import Contact from "../components/Contact";

export default {
  name: "Project2",
  components: {
    Header,
    Footer,
    Project2Details,
    Contact,
  }
};
</script>
